import { useAuth } from '@ixigo-packages/login/react';
import { useEffect, useState } from 'react';

/**
 * The signed-in user from the login package, which fetches and caches it.
 * `user` is null when it couldn't be loaded; the form then starts empty.
 */
export function useSignedInUser() {
	const { user, getUser } = useAuth();
	const [isLoading, setIsLoading] = useState(!user);

	useEffect(() => {
		let active = true;
		getUser().finally(() => {
			if (active) setIsLoading(false);
		});
		return () => {
			active = false;
		};
	}, [getUser]);

	return { user, isLoading };
}
